const useInitialUrl = (url = localStorage.getItem("pending_initial_choice") ? '/admin/initial' : '/admin/dashboard') => {
  //Get url of the original request
  const unallowRoutes = ['/auth/login-page', '/auth/lock-screen-page'];
  const urlInitial = localStorage.getItem('tsp-url');
  return urlInitial && !unallowRoutes.includes(urlInitial)
    ? urlInitial
    : url;
};
export default useInitialUrl;
